var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-content tw-bg-gray-50 tw-min-h-screen tw-w-full"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }